import SectionTitle from '@components/home/sectionTitle';
import TextAnswersArray from '@components/textAnswers/textAnswersArray';
import { HOME } from '@constants';
import styled from '@emotion/styled';
import { GetTextAnswerQuery } from '@graphql/generated/graphql';
import { useTranslation } from 'next-i18next';
import { StateResultsProvided } from 'react-instantsearch-core';
import { connectStateResults } from 'react-instantsearch-dom';

type TextAnswer = NonNullable<GetTextAnswerQuery['textAnswer']>;

const Container = styled.div`
    margin-top: ${(props) => props.theme.spacing.sm};
`;

const TitleContainer = styled.div`
    padding-inline-start: ${(props) => props.theme.spacing.md};
`;

const Content = styled.h2`
    margin-top: ${(props) => props.theme.spacing.xs};
    padding-inline: ${(props) => props.theme.spacing.xs};
`;

const Hits = ({ searchResults }: StateResultsProvided<TextAnswer>) => {
    const { t } = useTranslation(HOME);
    const validQuery = true;
    // ... searchState.query?.length >= 3; Can be used to hide the results until something  is entered in the search bar

    return (
        <>
            {searchResults?.hits.length > 0 && validQuery && (
                <Container>
                    <TitleContainer>
                        <SectionTitle className='questions_hits_title'>
                            {t('text_answers_sect_title')}
                        </SectionTitle>
                    </TitleContainer>
                    <Content>
                        <TextAnswersArray
                            textAnswers={searchResults.hits}
                            searchResults={searchResults}
                        />
                    </Content>
                </Container>
            )}
        </>
    );
};

export default connectStateResults(Hits);
